export const useEndCTAContent = () => {
  const contacts = [
    { type: 'location', text: 'Lidingö, Stockholm ' },
    { type: 'email', text: 'sheconomi@gmail.com' },
    { type: 'phone', text: '+46 7 62 68 61 76 ' },
    { type: 'hours', text: 'Mån-Fre\n08:00-16:00' },
  ];

  const socials = [
    { type: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/share/18DqdudsVa/?mibextid=wwXIfr' },
    { type: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/shekonomi?igsh=NGNvbmc3OTRvem5w' },

  ];

  return { contacts, socials };
};

export const useEndCTA = useEndCTAContent;
